import React from "react";
import "./styles/loader.scss";

export const Loader = () => {
  return (
    <div className="container">
      <div className="loader"></div>
    </div>
  );
};
